<template>
  <div class="rt-list-dropdown">
    <el-dropdown
      ref="dropdown"
      v-bind="$attrs"
      trigger="click"
      placement="bottom-start"
      @command="handleCommand"
      @keydown.native="handleKeydown"
    >
      <div
        class="rt-list-dropdown-content"
        @click="dropdownClick"
      >
        <p
          v-if="!multiple"
          class="rt-list-dropdown-title"
        >
          {{ computedSelectedName }}
        </p>
        <p
          v-else
          class="rt-list-dropdown-title"
        >
          {{ selectedTitle }}
        </p>
        <rt-icon
          :name="showMore ? 'rt-base-angle_up' : 'rt-base-angle_down'"
          size="16"
        />
      </div>

      <!-- 单选 -->
      <el-dropdown-menu
        v-if="!multiple"
        slot="dropdown"
      >
        <rt-search
          v-if="filterable"
          v-model="searchValue"
          :more="false"
          :placeholder="$tx('请搜索', 'xpc.common.pleaseSearch')"
        ></rt-search>
        <div class="rt-dropdown-item_content">
          <el-dropdown-item
            v-for="(item, index) in filterList"
            :key="index"
            :icon="item.icon"
            :command="index"
            :class="computedSelectedActive(item)"
          >
            <div :class="slotStyle">
              <div
                class="rt-dropdown-item-text"
                v-html="highlightKey(item.name)"
              ></div>
              <slot name="dropdownslot"></slot>
            </div>
          </el-dropdown-item>
        </div>
      </el-dropdown-menu>

      <!-- 多选 -->
      <transition
        v-else
        name="el-zoom-in-top"
      >
        <el-dropdown-menu v-show="showMore">
          <div
            ref="wrapper"
            class="rt-dropdown__dropdown-multiple"
          >
            <rt-search
              v-if="filterable"
              v-model="searchValue"
              :more="false"
              :placeholder="$tx('请搜索', 'xpc.common.pleaseSearch')"
            ></rt-search>
            <div
              ref="content"
              class="rt-dropdown__dropdown__content"
            >
              <div
                v-for="(item, index) in filterList"
                :key="index"
                :class="{
                  'is-checked': item.isActive,
                  'is-hover': index === currentItemIndex
                }"
                class="rt-dropdown-item"
                @click="itemClick(item, index)"
              >
                <div
                  :class="slotStyle"
                  class="rt-dropdown-item-content"
                >
                  <span class="rt-dropdown-item__title">
                    <span v-html="highlightKey(item.name)"></span>
                  </span>
                  <slot name="dropdownslot"></slot>
                  <rt-icon
                    v-if="item.isActive"
                    :size="16"
                    :color="SCSS_VARIABLES.COLOR_PRIMARY"
                    name="rt-base-check-lined"
                  ></rt-icon>
                </div>
              </div>
            </div>
          </div>
          <div class="footer">
            <rt-button-group>
              <rt-button
                text
                @click="reset"
              >
                {{ $tx('重置', 'xpc.common.reset') }}
              </rt-button>
              <rt-button
                text
                type="plain"
                @click="confirm"
              >
                {{ $tx('确定', 'xpc.common.ok') }}
              </rt-button>
            </rt-button-group>
          </div>
        </el-dropdown-menu>
      </transition>
      <transition name="rt-fade-linear">
        <div
          class="rt-dropdown__dropdown__mask"
          @click="hide"
        ></div>
      </transition>
    </el-dropdown>
  </div>
</template>

<script>
import RtIcon from '../../icon/rtIcon';
import RtSearch from '../../search/rtSearch.vue';
import RtButtonGroup from '../../button/rtButtonGroup.vue';
import RtButton from '../../button/rtButton.vue';
import ElDropdown from '../../../element-ui/packages/dropdown/src/dropdown.vue';
export default {
  name: 'RtListDropdown',
  components: {
    RtIcon,
    RtSearch,
    RtButtonGroup,
    RtButton,
    ElDropdown
  },
  props: {
    menuList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    value: {
      type: Number,
      default: 0
    },
    filterable: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    align: {
      type: String
    }
  },
  data () {
    return {
      showMore: false,
      selected: this.value,
      searchValue: '',
      filterList: this.menuList,
      selectedTitle: this.$tx('请选择', 'xpc.common.pleaseSelect'),
      multipleItem: [],
      currentItemIndex: -1
    };
  },
  computed: {
    // 计算当前插槽的样式【优化插槽样式】
    slotStyle () {
      let classlist = [];
      // 插槽中父元素的对齐方式
      if (this.align) {
        classlist.push(`rt-dropdown-item_${this.align}`);
      }
      return classlist;
    },
    hasIcon () {
      return !!this.icon;
    },
    computedSelectedName () {
      return (
        this.filterList[this.selected] && this.filterList[this.selected].name
      );
    },
    // 计算单选中样式-当前选中的的value和name跟必须和下拉框中一致
    computedSelectedActive () {
      return item => {
        if (item.name === this.computedSelectedName && item.value === this.selected) {
          return 'is-checked'
        }
      };
    }
  },
  watch: {
    menuList (val) {
      this.filterList = val;
    },
    value (newValue) {
      this.selected = newValue;
    },
    searchValue: {
      handler (val) {
        this.filterList = this.menuList.filter(item => {
          return item.name.indexOf(val) !== -1;
        });
      }
    },
    showMore (val) {
      if (val) {
        document.body.addEventListener('keydown', this.handleKeydown);
      } else {
        document.body.removeEventListener('keydown', this.handleKeydown);
      }
    }
  },
  created () {
    this.filterList.forEach(item => {
      item.isActive = false;
    });
  },
  mounted () {
    // 点击其他区域关闭下拉菜单
    const fn = e => {
      if (!this.$el.contains(e.target)) this.showMore = false;
    };
    document.addEventListener('click', fn);

    this.$once('hook:beforeDestroy', () => {
      document.removeEventListener('click', fn);
    });
  },
  destroyed () {
    document.removeEventListener('click', this.documentClick);
  },
  methods: {
    handleKeydown (event) {
      const keyCode = event.keyCode;
      let directionKey = [37, 38, 39, 40].indexOf(keyCode) > -1;
      if (!this.multiple) {
        // 单选键盘操作
        if (directionKey) {
          this.$refs.dropdown.show();
          event.preventDefault();
        }
      } else {
        // 多选键盘操作
        // 方向键
        if (directionKey) {
          if (!this.$refs.dropdown.visible) {
            this.$refs.dropdown.show();
          }
          this.showMore = true;

          event.preventDefault();
          event.stopPropagation();
        }

        const max = this.filterList.length - 1;

        // up / down 切换选项
        if ([38, 40].indexOf(keyCode) > -1) {
          if (keyCode === 38) {
            // up
            this.currentItemIndex =
                this.currentItemIndex !== 0 ? this.currentItemIndex - 1 : max;
          } else {
            // down
            this.currentItemIndex =
                this.currentItemIndex < max ? this.currentItemIndex + 1 : 0;
          }
          this.$nextTick(() => {
            this.scrollIntoView(keyCode);
          });
          event.preventDefault();
          event.stopPropagation();
        } else if (keyCode === 13) {
          // enter选中
          this.$refs.dropdown.show();
          this.showMore = true;

          let item = this.filterList[this.currentItemIndex];

          if (item && this.$refs.dropdown.visible) {
            this.itemClick(item);
          }

          event.preventDefault();
          event.stopPropagation();
          return;
        }

        // Tab
        if (keyCode === 9) {
          if (!this.showMore) return;
          this.showMore = !this.showMore;
        }
      }
    },

    scrollIntoView () {
      let contentRef = this.$refs.content;
      let target = contentRef && contentRef.querySelector('.is-hover'); // 目标元素
      target && target.scrollIntoView();
    },
    documentClick (e) {
      if (!this.$el.contains(e.target)) {
        this.hide();
      }
    },
    dropdownClick () {
      this.showMore = !this.showMore;
    },
    handleCommand (val) {
      this.selected = val;
      this.showMore = this.multiple;
      this.$emit('input', val);
    },
    // 重置
    reset () {
      this.selectedTitle = this.$tx('请选择', 'xpc.common.pleaseSelect');
      this.filterList.forEach(item => {
        item.isActive = false;
      });
      this.multipleItem = [];
      this.filterList = [...this.filterList];
    },
    // 确认
    confirm () {
      if (this.multipleItem.length === 0) {
        this.selectedTitle = this.$tx('请选择', 'xpc.common.pleaseSelect');
      } else {
        this.selectedTitle = this.multipleItem.join(', ');
      }
      this.hide();
    },
    // 隐藏下拉菜单
    hide () {
      this.searchValue = '';
      this.showMore = false;
      if (this.$refs.dropdown) {
        this.$refs.dropdown.hide();
      }
    },
    itemClick (item) {
      if (!item.isActive) {
        // 新增选项
        this.multipleItem.push(item.name);
        item.isActive = true;
      } else {
        // 移除选项
        const removeIndex = this.multipleItem.indexOf(item.name);
        if (removeIndex > -1) {
          this.multipleItem.splice(removeIndex, 1);
        }
        item.isActive = false;
      }
      this.filterList = [...this.filterList];
    },
    highlightKey (text) {
      const reg = new RegExp(this.searchValue, 'g');
      return text ? text.replace(
        reg,
        `<span style='color:#ff9500;'>${this.searchValue}</span>`
      ) : '';
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtListDropdown.vue?29580484